import { render, staticRenderFns } from "./lunchslideshow.vue?vue&type=template&id=4295827a&scoped=true"
import script from "./lunchslideshow.vue?vue&type=script&lang=js"
export * from "./lunchslideshow.vue?vue&type=script&lang=js"
import style0 from "./lunchslideshow.vue?vue&type=style&index=0&id=4295827a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4295827a",
  null
  
)

export default component.exports